import React from "react";
import { useWebViewBridge } from "@/contexts/WebViewBridgeContext";
import { MdNotificationsActive } from "react-icons/md";

const NotificationPermissionModal: React.FC = () => {
  const {
    rnNotifPermissionDenied,
    setRnNotifPermissionDenied,
    openAppSettings,
  } = useWebViewBridge();

  const handleClose = () => {
    setRnNotifPermissionDenied(false);
  };

  const handleOpenSettings = () => {
    openAppSettings();
    handleClose(); // Auto-dismiss modal
  };

  if (!rnNotifPermissionDenied) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="notification-modal-title"
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm"
      onClick={handleClose}
    >
      <div
        className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Icon */}
        <div className="flex justify-center mb-4 ">
          <span className="bg-lightPrimary p-4 rounded-full text-primary">
            <MdNotificationsActive size={24} />
          </span>
        </div>

        {/* Title */}
        <h2
          id="notification-modal-title"
          className="text-xl font-bold text-center mb-2 text-gray-800"
        >
          Notifications Disabled
        </h2>

        {/* Description */}
        <p className="text-center text-gray-600 mb-6 mt-4">
          You're missing out on important updates! Enable notifications so you
          never miss critical alerts and timely information.
        </p>

        {/* Buttons */}
        <div className="flex flex-col gap-3">
          <button
            onClick={handleOpenSettings}
            className="w-full px-6 py-3 bg-primary text-white rounded-lg font-semibold hover:bg-primary/90 transition-colors active:scale-[0.98]"
          >
            Open Settings
          </button>
          <button
            onClick={handleClose}
            className="w-full px-6 py-3 bg-transparent text-gray-500 rounded-lg font-semibold hover:bg-gray-50 transition-colors active:scale-[0.98]"
          >
            Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationPermissionModal;
